<template>
  <!-- 계획 탭 상단 버튼 영역이 사용되는 영역인지 알 수 없어 수정하지않고 TAB 위치 강제 적용 style영역 삭제시 원복가능 --> 
  <el-tabs class="default type2" @tab-click="handleClick" v-model="activeTabName" >
    <el-tab-pane
      v-for="(tab, index) in filterTabList"
      :key="index"
      :name="tab.prcssTypeCd + '_' + tab.ticktId"
    >
      <!-- :label="tab.wflowPrcssHnglNm + ' (' + tab.ticktSttusCdHnglNm + '-' + tab.filterWrkNm + ')'" -->
      <!-- :class="tab.isWrite ? 'el-tab-background' : ''" --> 
      <span slot="label" :class="tab.isWrite ? 'el-tab-background' : ''">{{ tab.wflowPrcssHnglNm + ' (' + tab.ticktSttusCdHnglNm + ' - ' + tab.filterWrkNm + ')' }}</span>
      <wrk-prcss-comm-btn v-if="!disabledBtn" :key="'btn_process_' + tab.ticktId"
        :location="'T'"
        :enableArea="tab.buttActvaYn == 'Y'"
        :exeWflowId="exeWflowId"
        :stepCd="stepCd"
        :ticktId="tab.ticktId"
        :activeButtonList="tab.actvButtCdList != null ? tab.actvButtCdList.split(',') : []"
        :allTicketList="allTicketList"
      ></wrk-prcss-comm-btn>
      <el-divider v-if="!disabledBtn"></el-divider>
      <template v-for="subprocess in filterProcessData">
        <template v-if="tab.wflowPrcssId == subprocess.upWflowPrcssId">
          <template v-for="scrn in screenData">
            <div :key="subprocess.wflowPrcssId + '_' + scrn.wflowScrnId"
              class="tab-table"
              v-if="wflowStepId == subprocess.wflowStepId && subprocess.wflowPrcssId == scrn.wflowPrcssId"
            >
              <div class="ly-detail-content">
                <wrk-comp
                  :isShowTitle="true"
                  :compTitle="scrn.scrnTitle"
                  :compNm="scrn.compNm"
                  :defaultValue="scrn.basDataSetupYn === 'Y' ? JSON.parse(scrn.basSetupData) : {}"
                  :exeWflowId="exeWflowId"
                  :svcCtlogId="svcCtlogId"
                  :depth1SvcCtlogId="depth1SvcCtlogId"
                  :depth2SvcCtlogId="depth2SvcCtlogId"
                  :prcssTypeCd="tab.prcssTypeCd"
                  :idcCd="idcCd"
                  :svcNo="svcNo"
                  :custId="custId"
                  :stepCd="stepCd"
                  :mainPrcssId="tab.wflowPrcssId"
                  :subPrcssId="subprocess.wflowPrcssId"
                  :wflowScrnId="scrn.wflowScrnId"
                  :scrnId="scrn.scrnId"
                  :mandDataChkYn="scrn.mandDataChkYn == 'Y' ? 'Y' : 'N'"
                  :sftyChkMandChkYn="scrn.sftyChkMandChkYn == 'Y' ? 'Y' : 'N'"
                  :sftyChkScrnYn="scrn.sftyChkScrnYn == 'Y' ? 'Y' : 'N'"
                  :scrnGetApi="scrn.getApi"
                  :scrnPostApi="scrn.postApi"
                  :scrnPutApi="scrn.putApi"
                  :scrnDeleteApi="scrn.deleteApi"
                  :ticktId="tab.ticktId"
                  :groupTicktId="tab.groupTicktId"
                  :allTicketList="allTicketList"
                ></wrk-comp>
              </div>
            </div>
          </template>
        </template>
      </template>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import WrkComp from "@/components/listComponents/wrkComponents/WrkComp.vue";
import WrkPrcssCommBtn from "@/components/listComponents/wrkComponents/WrkPrcssCommBtn.vue";

export default {
  components: {
    WrkComp,
    WrkPrcssCommBtn,
  },
  props: {
    disabledBtn: {
      type: Boolean,
      default: false,
    },
    wflowStepId: {
      type: String,
      default: "",
    },
    iTabGroupNum: {
      type: Number,
      default: 0,
    },
    tabProcessData: {
      type: Array,
      default: () => [],
    },
    processData: {
      type: Array,
      default: () => [],
    },
    screenData: {
      type: Array,
      default: () => [],
    },
    compNm: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    exeWflowId: {
      type: String,
      default: '',
    },
    svcCtlogId: {
      type: String,
      defautl: '',
    },
    depth1SvcCtlogId: {
      type: String,
      default: '',
    },
    depth2SvcCtlogId: {
      type: String,
      default: '',
    },
    idcCd: {
      type: String,
      default: '',
    },
    svcNo: {
      type: String,
      default: '',
    },
    custId: {
      type: String,
      default: '',
    },
    ticketInfo: {
      type: Array,
      default: () => [],
    },
    stepCd: {
      type: Number,
      default: 0
    },
    allTicketList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      activeTabName: '',
      crrFilterTicket: []
    };
  },
  mounted() {
    // 첫번째 탭 클릭
    if (this.activeTabName == 0 && this.filterTabList.length > 0) {
      const tmp = this.filterTabList[0];
      this.activeTabName = tmp.prcssTypeCd + '_' + tmp.ticktId;
    }
    // TODO 몇번째 탭으로 이동할지 계산하는 로직 필요.
  },
  computed: {
    filterProcessData() {
      let targetPrcssIds = [];

      const splitData = this.activeTabName.split("_");
      for (let process of this.processData) {
        if (process.prcssTypeCd == Number(splitData[0])) {
          targetPrcssIds.push(process.wflowPrcssId);
        }
      }

      return this.processData.filter(tmpProcess => {
        if ( targetPrcssIds.indexOf(tmpProcess.upWflowPrcssId) > -1 ) {
          return tmpProcess;
        }
      });
    },
    filterTabList() {
      /* 정렬 (내작업 우선)
      let filterProcessData = this.tabProcessData.filter((tab, index) => {
        if (this.wflowStepId == tab.wflowStepId && this.iTabGroupNum == tab.iTabGroupNum && tab.isChild && tab.isWrite) {
          if (tab.asgnrNm == null) {
            tab.filterWrkNm = tab.asgnWrkGroupNm;
          }
          else {
            tab.filterWrkNm = tab.asgnrNm;
          }
          return tab;
        }
      });
      this.tabProcessData.forEach((tab, index) => {
        if (this.wflowStepId == tab.wflowStepId && this.iTabGroupNum == tab.iTabGroupNum && tab.isChild && !tab.isWrite) {
          if (tab.asgnrNm == null) {
            tab.filterWrkNm = tab.asgnWrkGroupNm;
          }
          else {
            tab.filterWrkNm = tab.asgnrNm;
          }
          filterProcessData.push(tab);
          return tab;
        }
      });
      return filterProcessData;
      */

      /* 정렬 전 */
      return this.tabProcessData.filter((tab, index) => {
        // TODO 정렬 내 티켓 우선 순위
        if (this.wflowStepId == tab.wflowStepId && this.iTabGroupNum == tab.iTabGroupNum && tab.isChild) {
          /*
          console.log(this.wflowStepId)
          console.log('탭 + ')
          console.log(tab)
          */

          if (tab.asgnrNm == null) {
            tab.filterWrkNm = tab.asgnWrkGroupNm;
          }
          else {
            tab.filterWrkNm = tab.asgnrNm;
          }

          return tab;
        }
      });
      
    },
  },
  methods: {
    handleClick(tab, event) {
    },
  },
};
</script>
<style lang="scss" scoped>
.ly {
  &-sort {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-his {
      padding: 0 0 8px 0;
    }
  }
  &-detail {
    &-top {
      padding-bottom: 0px;
    }
    &-content {
      padding: 0;
    }
    &-footer {
      justify-content: space-between;
    }
  }
}
.el-tab-background {
  background: #dfeeff;
  // font-weight: bold;
  color: #34558a;
  display: inline-block;
  width: 100%;
  border-left: 2px solid #fff;
  border-right: 2px solid #fff;
  // padding: 0 5px;
}
::v-deep {
  .el-tabs__nav-wrap{
    margin-bottom: 0 !important;
  }
  .el-divider{
    margin: 0;
  }
  .ly-detail-footer{
    padding: 5px;
    min-height: 44px;
  }


  .el-tabs__nav {
    min-width: max-content;
    &-next, &-prev{
      width: 28px;
      z-index: 3;
      text-align: center;
      background-color: $--color-primary;
      color:  $--color-white;
      font-size: 1.2rem;
      line-height: 38px;
    }
  }
  .el-tabs__item {
    width: 268px;
  }
}
</style>
